// 客户管理相关
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;


// 赠险费率-选项列表-保司
export const getZxRateInsuranceCompanyOptions = (params) => {
  return get(baseApi + '/zxProduct/getCompanyList', params);
}
// 赠险费率-选项列表-数据类型
export const getZxRateInsuranceDataTypeOptions = (params) => {
  return get(baseApi + '/zxProduct/getPolicyTypeList', params);
}
// 赠险费率-选项列表-赠险CODE
export const getZxRateInsuranceCodeOptions = (params) => {
  return get(baseApi + '/zxProduct/getPolicyCodeListByCompany', params);
}
// 赠险费率-列表
export const getZxRateList = (params) => {
  return post(baseApi + '/zxProduct/getZxSettlementRateList', params);
}
// 赠险费率-状态修改
export const zxRateStatusChange = (params) => post(baseApi + '/zxProduct/modifySettlementRate', params);
// 赠险费率-删除
export const zxRateDelete = (params) => post(baseApi + '/zxProduct/deleteZxSettlementRate', params);
// 赠险费率-添加、修改
export const zxRateAddOrUpdate = (params) => {
  if (params.id > 0) {
    return post(baseApi + "/zxProduct/modifySettlementRate", params);
  } else {
    return post(baseApi + "/zxProduct/addZxSettlementRate", params);
  }
}

